import { render } from "./IpsList.vue?vue&type=template&id=0100fdc6"
import script from "./IpsList.vue?vue&type=script&lang=js"
export * from "./IpsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__